import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../utils/context";

const Referal = () => {
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState(0);

  const [selectedLevelUsers, setSelectedLevelUsers] = useState([]);
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState({});
  const GetEditData = async () => {
    try {
      setLoading(true);

      const response = await getData(
        `/admin/members/referral-users/${id}?level_id=${
          selectedLevel > 0 ? selectedLevel : ""
        }`,
      );

      setData(response?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const [level, setLevel] = useState([]);

  const getAllLevel = async () => {
    try {
      const response = await getData(`/common/masters/all-level`);

      if (response?.success) {
        setLevel([
          {
            id: 0,
            name: "Total",
          },
          ...(response?.data || []),
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        await Promise.all([GetEditData(), getAllLevel()]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [selectedLevel]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <section className="Create">
      <div className="back_btn_holder">
        <div onClick={() => navigate(-1)}>
          <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
          Back
        </div>
      </div>
      {/* <div
                style={{
                    padding: "20px",
                    background: "#f5f5f5",
                    minHeight: "100vh",
                }}
            > */}

      <div
        style={{
          background: "linear-gradient(135deg, #b8d7ff 0%, #5ca7ff 100%)",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col md={3}>
            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "600" }}>Customer Name</div>

              <div>{data?.User?.name}</div>
            </div>

            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "600" }}>Customer Number</div>

              <div>{data?.User?.contact_no}</div>
            </div>

            <div>
              <div style={{ fontWeight: "600" }}>Total Bonus</div>

              <div>{data?.User?.total_commission || 0}</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Main Section */}
      <Row
        style={{
          background: "#fff",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        {/* LEFT SIDE */}
        <Col
          md={6}
          style={{
            borderRight: "1px solid #ddd",
            maxHeight: "500px",
            overflowY: "auto",
            padding: "10px",
          }}
        >
          {data?.Level?.map((level, index) => (
            <div
              key={index}
              onClick={() => {
                setSelectedLevel(level?.id);

                setSelectedLevelUsers(level.users || []);
              }}
              style={{
                borderBottom: "1px solid #aaa",
                padding: "18px 10px",
                cursor: "pointer",
                borderRadius: "8px",
                marginBottom: "15px",
                background:
                  Number(selectedLevel) === Number(level.id)
                    ? "linear-gradient(135deg, #b8d7ff 0%, #5ca7ff 100%)"
                    : "transparent",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <strong>{level.name}</strong>

                <strong>
                  {level.id === 0
                    ? level?.total_users || 0
                    : `Total Users : ${level?.total_users || 0}`}
                </strong>
              </div>

              <button
                type="button"
                style={{
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "none",
                  background: "#666",
                  color: "#fff",
                  fontSize: "8px",
                }}
              >
                ➜
              </button>
            </div>
          ))}
        </Col>

        {/* RIGHT SIDE */}
        <Col
          md={6}
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            padding: "15px",
            background: "#f8f8f8",
          }}
        >
          {data?.Referrals?.length > 0 ? (
            data?.Referrals?.map((user, index) => (
              <div
                key={index}
                style={{
                  background: "#eef3f8",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "18px",
                  marginBottom: "18px",
                }}
              >
                <Row>
                  <Col md={6}>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Customer Name
                    </div>

                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Customer Number
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Customer UID
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Refer ID
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Joining Bonus
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Repurchase Bonus
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      Total Bonus
                    </div>
                  </Col>

                  <Col md={6}>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.ReferralTo?.name || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.ReferralTo?.contact_no || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.ReferralTo?.user_uid || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.ReferralTo?.refer_code || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.joining_commission || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.repurchase_commission || "-"}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      {user?.total_commission || "-"}
                    </div>
                  </Col>
                </Row>
              </div>
            ))
          ) : (
            <div className="text-center mt-5">No Data Found</div>
          )}
        </Col>
      </Row>

      {/* </div> */}
    </section>
  );
};

export default Referal;
